<template>
  <div class="tipo">
    <div class="conteudo" id="conteudo_tipo">
      <div class="form-group">
        <label for="TipoDeGrafico">Tipos de gráfico</label>
        <select v-model="tipoDeGrafico" class="form-control" id="TipoDeGrafico">
          <option value="1">1D</option>
          <option value="2" selected>Density Plot</option>
          <option value="3">3 D</option>
        </select>
      </div>
      <br>
      <div class="form-group">
        <label for="DirecaoDePropagacao">Direção:</label>
        <select v-model="direcaoDePropagacao" class="form-control" id="DirecaoDePropagacao">
          <option value="1" selected>+1</option>
          <option value="2">-1</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tipoGrafico",
  data() {
    return {
      direcaoDePropagacao: "1",
      tipoDeGrafico: "2"
    };
  },
  methods: {
    defineVariaveis: function() {
      this.$emit("select_tipo_feixe", {
        dados: {
          tipo_feixe: this.tipo_feixe
        }
      });
    }
  }
};
</script>